import { formatDateTime } from "../../../Component/Common/formatDateTime";
import { ROLE_LABELS } from "../../../Component/Common/ROLE_LABELS";
import Badge from "../../../Component/RetUserComponents/Badge";
import SectionCard from "../../../Component/RetUserComponents/SectionCard";
import Account from "../../Profile/Account";
import { useEffect, useRef, useState } from "react";
import { BASE_URL } from "../../../config/api";

import { Eye, EyeOff } from "lucide-react";
import { toast } from "react-hot-toast";
import axios from "axios";




export default function ProfileView({}) {

  const authUserString = localStorage.getItem("authUserData");
  const authUser = authUserString ? JSON.parse(authUserString) : null;

  const LoginUserName = authUser?.name || authUser?.business_name || authUser?.first_name;
  const loginUserCode = authUser?.org_code;
  const userRole = authUser?.role;

  const isMpinActive = authUser?.is_mpin_active === 1;

  const fileInputRef = useRef(null);
  const [uploading, setUploading] = useState(false);


  const [oldPassword, setOldPassword] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");

  const [showOld, setShowOld] = useState(false);
  const [showNew, setShowNew] = useState(false);
  const [showConfirm, setShowConfirm] = useState(false);

  const [changing, setChanging] = useState(false);

  // const [showMpinModal, setShowMpinModal] = useState(false);
  const [newMpin, setNewMpin] = useState(["", "", "", ""]);
  const [confirmMpin, setConfirmMpin] = useState(["", "", "", ""]);
  const newRefs = useRef([]);
  const confirmRefs = useRef([]);


  const [isMobile, setIsMobile] = useState(window.innerWidth < 640);

useEffect(() => {
  const handleResize = () => setIsMobile(window.innerWidth < 640);
  window.addEventListener("resize", handleResize);
  return () => window.removeEventListener("resize", handleResize);
}, []);

 const isRetailerMobile =
    (Number(authUser?.role) === 5 || Number(authUser?.role) === 6) && isMobile;

  const passwordRules = {
  length: (v) => v.length >= 8,
  upper: (v) => /[A-Z]/.test(v),
  lower: (v) => /[a-z]/.test(v),
  digit: (v) => /\d/.test(v),
  special: (v) => /[^A-Za-z0-9]/.test(v),
};

function validatePassword(pwd) {
  return {
    length: passwordRules.length(pwd),
    upper: passwordRules.upper(pwd),
    lower: passwordRules.lower(pwd),
    digit: passwordRules.digit(pwd),
    special: passwordRules.special(pwd),
  };
}

const passwordStatus = validatePassword(newPassword);
const allValid =
  Object.values(passwordStatus).every(Boolean) &&
  newPassword === confirmPassword &&
  oldPassword.length > 0;



  const formatList = (value) => {
  if (!value) return null;
  if (Array.isArray(value)) return value.join(", ");
  return value;
};

const handlePhotoChange = async (e) => {
  const file = e.target.files[0];
  if (!file) return;

  try {
    setUploading(true);

    /* ---------------- STEP 1: UPLOAD FILE ---------------- */
    const uploadForm = new FormData();
    uploadForm.append("file", file);
    uploadForm.append("tag", "logo");

    const uploadRes = await fetch(`${BASE_URL}warranty/upload-file`, {
      method: "POST",
      body: uploadForm,
    });

    const uploadJson = await uploadRes.json();
    if (!uploadRes.ok || !uploadJson?.data?.file_url) {
      throw new Error("File upload failed");
    }

    const fileUrl = uploadJson.data.file_url;

    /* ---------------- STEP 2: UPDATE PROFILE ---------------- */
    const updateRes = await fetch(`${BASE_URL}common/update`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        contact_email: authUser.contact_email,
        logo: fileUrl,
        pincode: authUser.pincode,
        role: authUser.role,
      }),
    });

    const updateJson = await updateRes.json();
    if (!updateRes.ok || !updateJson.status) {
      throw new Error("Profile update failed");
    }

    /* ---------------- STEP 3: UPDATE SESSION ---------------- */
    const updatedUser = {
      ...authUser,
      logo: fileUrl,
    };

    localStorage.setItem("authUserData", JSON.stringify(updatedUser));

    /* ---------------- STEP 4: REFRESH UI ---------------- */
    window.dispatchEvent(new Event("storage"));

  } catch (err) {
    console.error(err);
    alert("Failed to update logo");
  } finally {
    setUploading(false);
  }
};

const handleBoxChange = (e, index, type = "new") => {
  const value = e.target.value.replace(/\D/g, "");

  if (!value) return;

  const updated =
    type === "new" ? [...newMpin] : [...confirmMpin];

  updated[index] = value[0];

  type === "new"
    ? setNewMpin(updated)
    : setConfirmMpin(updated);

  // Move to next input
  if (index < 3) {
    const nextRef =
      type === "new"
        ? newRefs.current[index + 1]
        : confirmRefs.current[index + 1];

    nextRef?.focus();
  }
};


const handleChangePassword = async () => {
  if (!allValid) return;

  try {
    setChanging(true);

    // ✅ Get user ID from local storage
    const userId = authUser?.id;

    // ✅ Decide endpoint based on role
    let endpoint = "";

    if ([1, 2, 4, 5].includes(authUser?.role)) {
      endpoint = `${BASE_URL}company/change-password/${userId}`;
    } else if (authUser?.role === 3) {
      endpoint = `${BASE_URL}company/employee/change-password/${userId}`;
    } else {
      throw new Error("Password change not allowed for this role");
    }

    const res = await fetch(endpoint, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        old_password: oldPassword,
        new_password: newPassword,
      }),
    });

    const json = await res.json();

    if (!res.ok || !json.status) {
      throw new Error(json.message || "Password change failed");
    }

    toast.success("Password changed successfully 🎉");

    setOldPassword("");
    setNewPassword("");
    setConfirmPassword("");
  } catch (err) {
    toast.error(err.message || "Failed to change password");
  } finally {
    setChanging(false);
  }
};

const handleSubmitMpin = async () => {
  const mpinValue = newMpin.join("");
  const confirmValue = confirmMpin.join("");

  if (mpinValue.length !== 4)
    return toast.error("Enter 4 digit MPIN");

  if (mpinValue !== confirmValue)
    return toast.error("MPIN does not match");

  try {
    const endpoint = isMpinActive
      ? `${BASE_URL}common/update-mpin`
      : `${BASE_URL}common/set-mpin`;

    await axios.post(endpoint, {
      company_id: authUser.id,
      m_pin: mpinValue,
    });

    toast.success(
      isMpinActive ? "MPIN updated" : "MPIN set successfully"
    );

    // Update local storage flag
    const updatedUser = {
      ...authUser,
      is_mpin_active: 1,
    };

    localStorage.setItem(
      "authUserData",
      JSON.stringify(updatedUser)
    );

    // setShowMpinModal(false);
    setNewMpin(["", "", "", ""]);
    setConfirmMpin(["", "", "", ""]);

  } catch (err) {
    toast.error("Failed to update MPIN");
  }
};

const roleDisplayName = {
    1: "Admin",
    2: "Master Channel Partner",
    3: "Employee",
    4: "Channel Partner",
    5: "Authorized Retail Partner",
    6: "Promoter",
    7: "Customer",
  };

  return (
    <div className="space-y-4">
      <SectionCard
        title="My Profile"
        isRetailerMobile={isRetailerMobile}
        // className="md:bg-white bg-white/10 backdrop-blur-2xl border border-white/30 shadow-[0_20px_50px_rgba(31,38,135,0.25)]"
      >
        <div className="flex flex-col md:flex-row gap-4 text-sm">
          <div className="flex-shrink-0 flex flex-col items-center gap-2">
            <div className="w-16 h-16 rounded-2xl bg-blue-600 flex items-center justify-center overflow-hidden">
              {authUser?.logo ? (
                <img
                  src={`${authUser.photo_url || authUser.logo}?v=${Date.now()}`}
                  alt="Profile"
                  className="w-full h-full object-cover"
                  onError={(e) => {
                    e.currentTarget.style.display = "none";
                  }}
                />
              ) : (
                <span className="text-white text-xl font-semibold">
                  {LoginUserName?.charAt(0)}
                </span>
              )}
            </div>
          {authUser?.role === 2 && (
           <button
              onClick={() => fileInputRef.current.click()}
              className="text-[11px] px-2.5 py-1.5 rounded-lg border border-slate-200 text-slate-700 bg-slate-50 hover:bg-slate-100"
            >
              {uploading ? "Uploading..." : "Edit Photo"}
            </button>
            )}
            <input
              type="file"
              ref={fileInputRef}
              accept="image/*"
              hidden
              onChange={handlePhotoChange}
            />

          </div>
          <div className="flex-1 grid grid-cols-1 md:grid-cols-2 gap-3">
            <div>
              <div className="text-[11px] text-slate-500">Full Name</div>
              <div className="text-sm font-semibold text-slate-800">
                {authUser?.contact_person || `${authUser?.first_name} ${authUser?.last_name}`}
              </div>
            </div>
            <div>
              <div className="text-[11px] text-slate-500">Role</div>
              <div className="text-sm font-semibold text-slate-800">
                {roleDisplayName[authUser?.role] || "Unknown"}
              </div>

            </div>
            <div>
              <div className="text-[11px] text-slate-500">Mobile</div>
              <div className="text-sm font-semibold text-slate-800">
                {authUser?.contact_phone || authUser?.official_phone}
              </div>
            </div>
            <div>
              <div className="text-[11px] text-slate-500">Email</div>
              <div className="text-sm font-semibold text-slate-800">
                {authUser?.contact_email || authUser?.official_email}
              </div>
            </div>
            { authUser?.role === 5 && (
            <div>
              <div className="text-[11px] text-slate-500">Store Name</div>
              <div className="text-sm font-semibold text-slate-800">
                {authUser?.business_name }
              </div>
            </div>
            )}
            <div>
                <div className="text-[11px] text-slate-500">
                  {authUser?.role === 3 ? "Assigned Location" : "Location"}
                </div>

                <div className="text-sm font-semibold text-slate-800">
                  {authUser?.role === 3 ? (
                    <>
                      {formatList(authUser?.district) && (
                        <span>{formatList(authUser.district)}</span>
                      )}

                      {formatList(authUser?.state) && (
                        <span>
                          {formatList(authUser.district) ? ", " : ""}
                          {formatList(authUser.state)}
                        </span>
                      )}

                      {formatList(authUser?.pincodes) && (
                        <span>
                          {(authUser.district || authUser.state) ? ", " : ""}
                          {formatList(authUser.pincodes)}
                        </span>
                      )}

                      {!authUser?.district && !authUser?.state && !authUser?.pincodes && (
                        <span className="text-slate-400">No location assigned</span>
                      )}
                    </>
                  ) : (
                    <>
                      {authUser?.address_line1 && <span>{authUser.address_line1}, </span>}
                      {authUser?.district && <span>{authUser.district}, </span>}
                      {authUser?.state && <span>{authUser.state}</span>}
                      {authUser?.pincode && <span>, {authUser.pincode}</span>}
                    </>
                  )}
                </div>
              </div>

            <div>
              <div className="text-[11px] text-slate-500">Joined On</div>
              <div className="text-sm font-semibold text-slate-800">
                {formatDateTime(authUser?.created_at)}
              </div>
            </div>
          </div>
        </div>
      </SectionCard>

      { authUser?.role === 2 &&( <Account/>)}

     {[1,2,3,4,5].includes(authUser?.role) && (
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-6">
          <div className="lg:col-span-6">

            <SectionCard title="Change Password">
              <div className="space-y-6 text-sm">
                {/* OLD PASSWORD */}
                <div className="relative">
                  <label className="text-sm font-medium text-slate-700 flex items-center gap-2">
                    Old Password
                    {oldPassword && (
                      <span className="text-emerald-500 text-xs">✔</span>
                    )}
                  </label>

                  <input
                    type={showOld ? "text" : "password"}
                    value={oldPassword}
                    onChange={(e) => setOldPassword(e.target.value)}
                    className="mt-2 w-full rounded-xl border-2 border-emerald-400 px-4 py-3 pr-10 font-semibold focus:outline-none"
                  />

                  <button
                    type="button"
                    onClick={() => setShowOld(!showOld)}
                    className="absolute right-3 top-10 text-slate-400"
                  >
                    {showOld ? <EyeOff size={18} /> : <Eye size={18} />}
                  </button>
                </div>

                {/* NEW PASSWORD */}
                <div className="relative">
                  <label className="text-sm font-medium text-slate-700">
                    New Password
                  </label>

                  <input
                    type={showNew ? "text" : "password"}
                    value={newPassword}
                    onChange={(e) => setNewPassword(e.target.value)}
                    className={`mt-2 w-full rounded-xl border-2 px-4 py-3 pr-10 font-semibold focus:outline-none ${
                      Object.values(passwordStatus).every(Boolean)
                        ? "border-emerald-400"
                        : "border-rose-400"
                    }`}
                  />

                  <button
                    type="button"
                    onClick={() => setShowNew(!showNew)}
                    className="absolute right-3 top-10 text-slate-400"
                  >
                    {showNew ? <EyeOff size={18} /> : <Eye size={18} />}
                  </button>

                  {/* RULES */}
                  <div className="mt-3 text-xs">
                    <p className="text-rose-500 font-medium mb-2">
                      Please add all necessary characters to create safe password.
                    </p>

                    <div className="grid grid-cols-1 sm:grid-cols-3 gap-y-2 gap-x-6">
                      {[
                        ["Minimum characters 8", passwordStatus.length],
                        ["One uppercase character", passwordStatus.upper],
                        ["One lowercase character", passwordStatus.lower],
                        ["One special character", passwordStatus.special],
                        ["One number", passwordStatus.digit],
                      ].map(([label, ok]) => (
                        <div
                          key={label}
                          className={`flex items-center gap-2 ${
                            ok ? "text-emerald-600" : "text-slate-400"
                          }`}
                        >
                          <span
                            className={`w-2 h-2 rounded-full ${
                              ok ? "bg-emerald-500" : "bg-slate-400"
                            }`}
                          />
                          {label}
                        </div>
                      ))}
                    </div>
                  </div>
                </div>

                {/* CONFIRM PASSWORD */}
                <div className="relative">
                  <label className="text-sm font-medium text-slate-700">
                    Confirm New Password
                  </label>

                  <input
                    type={showConfirm ? "text" : "password"}
                    value={confirmPassword}
                    onChange={(e) => setConfirmPassword(e.target.value)}
                    className={`mt-2 w-full rounded-xl border-2 px-4 py-3 pr-10 font-semibold focus:outline-none ${
                      confirmPassword && newPassword === confirmPassword
                        ? "border-emerald-400"
                        : "border-slate-300"
                    }`}
                  />

                  <button
                    type="button"
                    onClick={() => setShowConfirm(!showConfirm)}
                    className="absolute right-3 top-10 text-slate-400"
                  >
                    {showConfirm ? <EyeOff size={18} /> : <Eye size={18} />}
                  </button>
                </div>

                {/* SUBMIT */}
                <button
                  disabled={!allValid || changing}
                  onClick={handleChangePassword}
                  className={`w-full rounded-xl py-3 font-semibold text-white transition ${
                    allValid
                      ? "bg-gradient-to-r from-blue-500 to-blue-600 hover:opacity-90"
                      : "bg-slate-300 cursor-not-allowed"
                  }`}
                >
                  {changing ? "Updating..." : "Change Password"}
                </button>
              </div>
            </SectionCard>
            </div>

            <div className="lg:col-span-6">
              <SectionCard title="MPIN Set Up" isRetailerMobile={isRetailerMobile}>
                <div className="space-y-6 text-center">

                  {/* STATUS */}
                  <div className="flex items-center justify-between gap-2">
                    <span className="text-sm font-semibold">
                      Status:
                    </span>
                    <Badge color={isMpinActive ? "green" : "gray"}>
                      {isMpinActive ? "Active" : "Not Set"}
                    </Badge>
                  </div>

                  {/* ENTER MPIN */}
                  <div>
                    <label className="text-[12px] text-slate-500 block mb-3">
                      {isMpinActive ? "New MPIN" : "Set MPIN"}
                    </label>

                    <div className="flex justify-center gap-3">
                      {newMpin.map((digit, index) => (
                        <input
                          key={index}
                          ref={(el) => (newRefs.current[index] = el)}
                          type="tel"
                          inputMode="numeric"
                          maxLength={1}
                          value={digit}
                          onChange={(e) => handleBoxChange(e, index, "new")}
                          className="w-14 h-14 border border-slate-300 rounded-xl text-center text-xl font-semibold focus:border-blue-500 focus:ring-2 focus:ring-blue-200 outline-none"
                        />
                      ))}
                    </div>
                  </div>

                  {/* CONFIRM MPIN */}
                  <div>
                    <label className="text-[12px] text-slate-500 block mb-3">
                      Confirm MPIN
                    </label>

                    <div className="flex justify-center gap-3">
                      {confirmMpin.map((digit, index) => (
                        <input
                          key={index}
                          ref={(el) => (confirmRefs.current[index] = el)}
                          type="tel"
                          inputMode="numeric"
                          maxLength={1}
                          value={digit}
                          onChange={(e) => handleBoxChange(e, index, "confirm")}
                          className="w-14 h-14 border border-slate-300 rounded-xl text-center text-xl font-semibold focus:border-blue-500 focus:ring-2 focus:ring-blue-200 outline-none"
                        />
                      ))}
                    </div>
                  </div>

                  {/* BUTTON */}
                  <button
                    onClick={handleSubmitMpin}
                    className="w-full bg-blue-600 text-white py-2.5 rounded-xl font-semibold hover:bg-blue-700 transition"
                  >
                    {isMpinActive ? "Update MPIN" : "Set MPIN"}
                  </button>

                </div>
              </SectionCard>
            </div>
        </div>
      )}

      <SectionCard title="Security & Login" isRetailerMobile={isRetailerMobile}>
        <div className="text-sm space-y-2">
          {/* <div className="flex items-center justify-between">
            <span>Two-factor authentication (2FA)</span>
            <Badge color="gray">Not configured</Badge>
          </div> */}
          <div className="flex items-center justify-between">
            <span>Active session on this device</span>
            <Badge color="green">Active</Badge>
          </div>
          <div className="text-[11px] text-slate-500 pt-2">
            For your security, do not share your login credentials with anyone.
          </div>
        </div>

      </SectionCard>

    </div>
  );
}



// import { formatDateTime } from "../../../Component/Common/formatDateTime";
// import { ROLE_LABELS } from "../../../Component/Common/ROLE_LABELS";
// import Badge from "../../../Component/RetUserComponents/Badge";
// import SectionCard from "../../../Component/RetUserComponents/SectionCard";
// import Account from "../../Profile/Account";



// export default function ProfileView({}) {

//   const authUserString = localStorage.getItem("authUserData");
//   const authUser = authUserString ? JSON.parse(authUserString) : null;

//   const LoginUserName = authUser?.name || authUser?.business_name || authUser?.first_name;
//   const loginUserCode = authUser?.org_code;
//   const userRole = authUser?.role;

//   const formatList = (value) => {
//   if (!value) return null;
//   if (Array.isArray(value)) return value.join(", ");
//   return value;
// };

//   return (
//     <div className="space-y-4">
//       <SectionCard title="My Profile">
//         <div className="flex flex-col md:flex-row gap-4 text-sm">
//           <div className="flex-shrink-0 flex flex-col items-center gap-2">
//             <div className="w-16 h-16 rounded-2xl bg-blue-600 text-white flex items-center justify-center text-xl font-semibold">
//               {LoginUserName.charAt(0)}
//             </div>
//             <button className="text-[11px] px-2.5 py-1.5 rounded-lg border border-slate-200 text-slate-700 bg-slate-50 hover:bg-slate-100">
//               Edit Photo
//             </button>
//           </div>
//           <div className="flex-1 grid grid-cols-1 md:grid-cols-2 gap-3">
//             <div>
//               <div className="text-[11px] text-slate-500">Full Name</div>
//               <div className="text-sm font-semibold text-slate-800">
//                 {authUser?.contact_person || `${authUser?.first_name} ${authUser?.last_name}`}
//               </div>
//             </div>
//             <div>
//               <div className="text-[11px] text-slate-500">Role</div>
//               <div className="text-sm font-semibold text-slate-800">
//                 {ROLE_LABELS[authUser?.role] || "Unknown"}
//               </div>

//             </div>
//             <div>
//               <div className="text-[11px] text-slate-500">Mobile</div>
//               <div className="text-sm font-semibold text-slate-800">
//                 {authUser?.contact_phone || authUser?.official_phone}
//               </div>
//             </div>
//             <div>
//               <div className="text-[11px] text-slate-500">Email</div>
//               <div className="text-sm font-semibold text-slate-800">
//                 {authUser?.contact_email || authUser?.official_email}
//               </div>
//             </div>
//             { authUser?.role === 5 && (
//             <div>
//               <div className="text-[11px] text-slate-500">Store Name</div>
//               <div className="text-sm font-semibold text-slate-800">
//                 {authUser?.business_name }
//               </div>
//             </div>
//             )}
//             <div>
//                 <div className="text-[11px] text-slate-500">
//                   {authUser?.role === 3 ? "Assigned Location" : "Location"}
//                 </div>

//                 <div className="text-sm font-semibold text-slate-800">
//                   {authUser?.role === 3 ? (
//                     <>
//                       {formatList(authUser?.district) && (
//                         <span>{formatList(authUser.district)}</span>
//                       )}

//                       {formatList(authUser?.state) && (
//                         <span>
//                           {formatList(authUser.district) ? ", " : ""}
//                           {formatList(authUser.state)}
//                         </span>
//                       )}

//                       {formatList(authUser?.pincodes) && (
//                         <span>
//                           {(authUser.district || authUser.state) ? ", " : ""}
//                           {formatList(authUser.pincodes)}
//                         </span>
//                       )}

//                       {!authUser?.district && !authUser?.state && !authUser?.pincodes && (
//                         <span className="text-slate-400">No location assigned</span>
//                       )}
//                     </>
//                   ) : (
//                     <>
//                       {authUser?.address_line1 && <span>{authUser.address_line1}, </span>}
//                       {authUser?.district && <span>{authUser.district}, </span>}
//                       {authUser?.state && <span>{authUser.state}</span>}
//                       {authUser?.pincode && <span>, {authUser.pincode}</span>}
//                     </>
//                   )}
//                 </div>
//               </div>

//             <div>
//               <div className="text-[11px] text-slate-500">Joined On</div>
//               <div className="text-sm font-semibold text-slate-800">
//                 {formatDateTime(authUser?.created_at)}
//               </div>
//             </div>
//           </div>
//         </div>
//       </SectionCard>

//       { authUser?.role === 2 &&( <Account/>)}

//       <SectionCard title="Security & Login">
//         <div className="text-sm space-y-2">
//           {/* <div className="flex items-center justify-between">
//             <span>Two-factor authentication (2FA)</span>
//             <Badge color="gray">Not configured</Badge>
//           </div> */}
//           <div className="flex items-center justify-between">
//             <span>Active session on this device</span>
//             <Badge color="green">Active</Badge>
//           </div>
//           <div className="text-[11px] text-slate-500 pt-2">
//             For your security, do not share your login credentials with anyone.
//           </div>
//         </div>
//       </SectionCard>
//     </div>
//   );
// }